import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

function Header({ loggeduser, selectedGame, sutramasterjsonfile }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("userId");
      localStorage.removeItem("authCode");
      localStorage.removeItem("name");
      alert("Signed out successfully!");
      navigate("/login");
    } catch (error) {
      alert("Error during logout: " + error.message);
    }
  };

  return (
    <>
      <div style={{ position: "absolute", right: 0, top: 0 }}>
        <div className="mx-4">{loggeduser}</div>
        <button
          className="btn btn-primary btn-sm mx-4 my-1"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
      <div
        style={{
          width: "400px",
          margin: "30px auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div>
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Sutra To Solve
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Levels</th>
                        <th scope="col">Chapters</th>
                        <th scope="col">Sutras</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sutramasterjsonfile.map((val) => (
                        <tr
                          key={`${val[0]}-${val[1]}-${val[2]}`}
                          style={{
                            backgroundColor:
                              val[2] === selectedGame ? "#edecec" : "#ffffff",
                          }}
                        >
                          <td>{val[0]}</td>
                          <td>{val[1]}</td>
                          <td>{val[2]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Header.propTypes = {
  loggeduser: PropTypes.string.isRequired,
  selectedGame: PropTypes.string.isRequired,
  sutramasterjsonfile: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default Header;
